import { NgModule } from '@angular/core';

import { MediaTypeFilterPipe } from './media-type-filter.pipe';

@NgModule({
  declarations: [MediaTypeFilterPipe],
  exports: [MediaTypeFilterPipe]
})
export class NguixDashboardMediaTypeFilterPipeModule { }
